module.exports = __webpack_public_path__ + "img/pc_p3_update.62713681.svg";